// src/utils/authSync.ts
export const syncClientWithServer = async () => {
    try {
      console.log('Synchronizing client state with server...');
      
      // 1. Get token if available
      //const token = localStorage.getItem('authToken');
      const token = localStorage.getItem('authToken') || 
              localStorage.getItem('token') || 
              localStorage.getItem('tripperSessionToken') ||
              localStorage.getItem('accessToken');
      
        console.log('Token found:', token);
      // No token = not authenticated, reset client state except identity
      if (!token) {

        // Check if we're in OAuth flow FIRST
        const isInOAuthFlow = window.location.hash.includes('auth-callback') || 
                            sessionStorage.getItem('socialAuthProvider');
        
        if (isInOAuthFlow) {
          console.log('In OAuth flow, skipping localStorage clear');
          return null; // Don't clear during OAuth
        }
        
        // Preserve identity data and logout state
        const preserveKeys = [
          'tripperUserEmail', 
          'tripperHasAccount', 
          'tripperUserExists', 
          'tripperCodeValidated', 
          'tripperLoggedOut', 
          'tripperFullName',
          'ENABLE_AUTH_DEBUG'
        ];
        
        // Save values we want to keep
        const preservedValues = preserveKeys.reduce((values, key) => {
          const value = localStorage.getItem(key);
          if (value) values[key] = value;
          return values;
        }, {});
        
        // Clear storage
        console.log('Local Storage Auth Cleared here: ------------------------ 1');
        localStorage.clear();
        sessionStorage.clear();
        
        // Restore preserved values
        Object.entries(preservedValues).forEach(([key, value]) => {
          localStorage.setItem(key, value);
        });
        
        console.log('No auth token found, client state reset while preserving identity and logout state');
        return false;
      }
      
      // 2. Verify token with server
      try {
        const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001';
        const response = await fetch(`${apiBaseUrl}/api/auth/verify`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        
        // Token invalid or expired
        if (!response.ok) {
          console.log('Token invalid or expired, clearing client state');
          
          // Clear auth related values but keep non-auth values
          ['tripperAuthenticated', 'authToken', 'tripperSessionToken', 'tripperLoggedOut', 'userData']
            .forEach(key => localStorage.removeItem(key));
          
          // Clear session values
          ['socialAuthSuccess', 'socialAuthProvider', 'socialAuthEmail', 'tripperAccountCreated']
            .forEach(key => sessionStorage.removeItem(key));
          
          return false;
        }
        
        // Token valid - update client state with server data
        const data = await response.json();
        console.log('Token verification response: -------------------------------------', data);
        console.log('[authSync] Token verification response:', {
          success: data.success,
          user: data.user ? {
            id: data.user.id,
            email: data.user.email,
            name: data.user.name
          } : null,
          hasAuthProvider: !!data.user?.authProvider,
          hasInviteCode: !!data.user?.inviteCode
        });
        
        if (data.success && data.user) {
          console.log('Token verification response SUCCESS : -------------------------------------', data);
          console.log('[authSync] Updating client state with:', {
            email: data.user.email,
            name: data.user.name,
            authProvider: data.user.authProvider?.providerType || 'none',
            inviteCodeUsed: data.user.inviteCode?.used || false
          });
          
          // Update localStorage with server data
          localStorage.setItem('tripperAuthenticated', 'true');
          localStorage.setItem('tripperHasAccount', 'true');
          localStorage.setItem('tripperUserEmail', data.user.email);
          
          // Fix the name issue
          if (data.user.name) {
            localStorage.setItem('tripperUserName', data.user.name);
          }
          
          localStorage.setItem('tripperUserId', data.user.id);
          localStorage.removeItem('tripperLoggedOut');
          
          // Add OAuth provider information
          const provider = sessionStorage.getItem('socialAuthProvider');
          if (provider) {
            localStorage.setItem('tripperAuthProvider', provider);
          }
          
          // Store user data
          localStorage.setItem('userData', JSON.stringify(data.user));
          
          // Trigger storage event for components listening
          /* window.dispatchEvent(new Event('storage'));
          window.dispatchEvent(new Event('tripperAuthenticated')); */
          // With a single, debounced event:
          const emitAuthEvent = debounce(() => {
            window.dispatchEvent(new CustomEvent('tripperAuthUpdate', {
              detail: { source: 'sync' }
            }));
          }, 500);
          emitAuthEvent();

          console.log('Client state synchronized successfully');
          return true;
        }
      } catch (error) {
        console.error('Error verifying token:', error);
        return null;
      }
    } catch (error) {
      console.error('Sync error:', error);
      return null;
    }
  };


  // Add this at the top of authSync.ts
function debounce(func: Function, wait: number) {
  let timeout: NodeJS.Timeout;
  return function executedFunction(...args: any[]) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}